<template>
    <div>
        <h2 class="mb-1">{{ $t("settings.users.teams.title") }}</h2>

        <b-form-group>
            <b-form-checkbox
                v-model="allSelected"
                :disabled="userData && userData.id && !userData.auth0Id"
                :indeterminate="indeterminate"
                @change="toggleAll"
            >
                {{ allSelected ? $t("settings.users.teams.deselect-all") : $t("settings.users.teams.select-all") }}
            </b-form-checkbox>
            <b-form-checkbox-group
                id="teams"
                v-model="userData.teams"
                :disabled="userData && userData.id && !userData.auth0Id"
                :options="teams"
                class="ml-4"
                name="teams"
                stacked
            ></b-form-checkbox-group>
        </b-form-group>

        <hr />
    </div>
</template>
<script>
import { BFormGroup, BFormCheckboxGroup, BFormCheckbox } from "bootstrap-vue";

export default {
    components: {
        BFormGroup,
        BFormCheckbox,
        BFormCheckboxGroup,
    },
    props: {
        userData: {
            type: Object,
            required: true,
        },
        teams: {
            type: Array,
            required: true,
        },
    },
    watch: {
        "userData.teams"(newValue, oldValue) {
            if (newValue.length === 0) {
                this.indeterminate = false;
                this.allSelected = false;
            } else if (newValue.length === this.teams.length) {
                this.indeterminate = false;
                this.allSelected = true;
            } else {
                this.indeterminate = true;
                this.allSelected = false;
            }
        },
    },
    methods: {
        toggleAll(checked) {
            this.userData.teams = checked ? this.teams.map((team) => team.value) : [];
        },
    },
    setup(props) {
        const allSelected =
            props.teams &&
            props.userData.teams &&
            props.teams.length > 0 &&
            props.teams.length === props.userData.teams.length;
        const indeterminate =
            props.teams &&
            props.userData.teams &&
            props.userData.teams.length > 0 &&
            props.teams.length > props.userData.teams.length;

        return {
            allSelected,
            indeterminate,
        };
    },
};
</script>
